import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TicketService } from '../../../services/http/tickets/tickets.service';
import { Ticket, TicketRquest } from '../../../services/http/tickets/tickets.interface';
import { Router } from '@angular/router';
import { LoaderService } from '../../../services/loader/loader.service';

@Component({
  selector: 'app-comunications',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './comunications.component.html',
  styleUrl: './comunications.component.scss'
})
export class ComunicationsComponent implements OnInit {
  comunications: Ticket[] = []
  newComunication: TicketRquest = {
    subject: '',
    message: ''
  }

  constructor(
    private readonly ticketService: TicketService,
    private readonly router: Router,
    private readonly loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.loaderService.show();
    this.ticketService.getApplicantTickets().subscribe((tickets) => {
      this.comunications = tickets.elements;
      this.loaderService.hide();
    })
  }

  selectTicket(ticketId: string) {
    this.router.navigate(['comunications', ticketId]);
  }

  createTicket() {
    this.loaderService.show();
    this.ticketService.addApplicantTicket(this.newComunication).subscribe((ticketId) => {
      this.loaderService.hide();
      this.router.navigate(['comunications', ticketId]);
    })
  }
}
